import React, { useState, useEffect, useRef, useCallback } from "react"
import "./EventLog.css";

import DataTable from "../../ui/table-v3/DataTable";
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import {_Q_getAllApplicationsPaged } from "../../query/queries";
import { fpnf } from '../dashboard/constants';

import { RefreshButton } from "../traceability/components/RefreshButton";
import HorizontalMenu from "../HorizontalMenu";
import { decamelize, getItemDB, setItemDB } from "../commons";
import PagedQuery from "../PagedQuery";
import { fetchDeployments } from "../dashboard/components/deploy-rollback-modal/deployRollbackModalService.js";
import { compress, decompress } from "../../utils/compression";
import { getCurrentApplication, getFormattedDate, getNotificationStatus } from "./helper.js";


export const EventLogIcon = ({ width = 20, height = 19 }) => (
    <svg height={height} viewBox="0 0 1024 1024" width={width} fill="currentColor">
  <path
    d="M670,863.6c5,0,3.6,6.3-4.4,18.9S645.5,909,629.2,924c-16.2,15.1-35.6,28.9-57.7,41.5c-22.2,12.6-46,18.9-71.1,18.9c-22.7,0-44.4-6.4-65.4-18.9c-20.9-12.6-39.4-26.4-55.3-41.5c-15.9-15.1-28.1-28.9-36.5-41.5c-8.4-12.6-10.9-18.9-7.6-18.9H670L670,863.6z M598.2,32.6c-50.6-7.6-204.8,2.5-204.8,2.5 M393.4,35.2c-26.8,9.2-52.6,22.7-77.3,40.2c-24.7,17.6-46.5,39-65.4,64.2c-18.9,25-34.2,54.4-45.9,87.9c-11.7,33.6-17.6,71.3-17.6,113.2c0,43.6-6.3,85.2-18.9,125.1c-12.6,39.8-27.5,77.5-44.6,113.2c-17.2,35.6-35.4,68.9-54.7,99.9c-19.3,31-36,59.1-50.3,84.3C9.5,777.4,7.6,789.3,13,799c5.4,9.7,14.1,14.4,25.7,14.4h917.8c5,0.1,10-1.4,15-4.3c5.1-3,9.3-6.9,12.6-11.9c3.4-5,5.3-11.1,5.7-18.3c0.5-7.1-2.3-14.5-8.1-22l-0.1-0.1c-15.9-21.8-33.7-47.8-53.4-78c-19.7-30.2-38.3-63.4-56-99.9c-17.5-36.5-32.6-75.1-45.2-115.7c-12.6-40.6-18.8-81.9-18.8-123.8c0-41.1-5.7-78.4-17-111.9c-11.3-33.4-26.4-63.3-45.3-89.2c-18.7-26-41-47.8-66.5-65.4c-25.7-17.7-52.7-31.1-81.3-40.3"
    fill="currentColor"
  />
  <path
    d="M670,860.1c5.1,0,3.6,6.3-4.3,18.9c-8,12.6-20.1,26.4-36.5,41.5c-16.2,15.1-35.6,28.9-57.7,41.5c-22.2,12.6-46,18.9-71.1,18.9c-22.7,0-44.4-6.4-65.4-18.9c-20.9-12.6-39.4-26.4-55.3-41.5c-15.9-15-28.1-28.9-36.5-41.5c-8.4-12.6-10.9-18.9-7.6-18.9H670L670,860.1z M598.2,29c-30.7-8.5-65.6-13.4-101.2-13.4c-35.1,0-70.8,4.9-103.6,15.8 M393.4,31.5c-26.8,9.3-52.6,22.7-77.4,40.3c-24.7,17.6-46.5,38.9-65.4,64.1c-18.8,25.1-34.1,54.4-45.9,88c-11.7,33.4-17.6,71.2-17.6,113.1c0,43.5-6.3,85.3-18.9,125c-12.6,39.9-27.5,77.5-44.6,113.2c-17.1,35.6-35.4,68.9-54.7,100c-19.3,31-36,59.1-50.3,84.3c-9.2,14.3-11.1,26.2-5.7,35.8c5.4,9.7,14.1,14.4,25.7,14.4h917.8c5,0,10-1.4,15-4.3c5.1-3,9.3-7,12.6-11.9c3.4-5.1,5.3-11.1,5.7-18.3c0.5-7.1-2.3-14.5-8.1-22l-0.1-0.1c-15.9-21.8-33.7-47.8-53.4-77.9c-19.7-30.1-38.3-63.4-56-99.9c-17.5-36.5-32.6-75-45.2-115.7c-12.6-40.6-18.8-81.9-18.8-123.9c0-41.1-5.7-78.4-17-111.8c-11.3-33.6-26.4-63.3-45.3-89.3c-18.7-26-41-47.8-66.5-65.4c-25.7-17.6-52.7-31.1-81.3-40.2"
    fill="currentColor"
  />
</svg>

);

const DEFAULT_COLUMN_SIZE = 142;

const DEF__ = (s = DEFAULT_COLUMN_SIZE) => ({
    size: parseInt(s),
    maxSize: parseInt(s),
    minSize: parseInt(s)
})

const getIcon = (userId) => {
    if (userId !== "system") {
        return (
            <svg
                width={24}
                height={24}
                viewBox="0 0 44 54"
                fill="none">
                <g style={{
                    transform: "scale(1.74) translate(0px, -2px)"
                }}>
                    <g clipPath="url(#clip0_7855_927)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.35 18.5C8.66 17.56 10.26 17 12 17C13.74 17 15.34 17.56 16.65 18.5C15.34 19.44 13.74 20 12 20C10.26 20 8.66 19.44 7.35 18.5ZM18.14 17.12C16.45 15.8 14.32 15 12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 13.95 19.3 15.73 18.14 17.12Z"
                            fill="#E8EAED"
                        />
                        <path
                            d="M12 6C10.07 6 8.5 7.57 8.5 9.5C8.5 11.43 10.07 13 12 13C13.93 13 15.5 11.43 15.5 9.5C15.5 7.57 13.93 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z"
                            fill="#E8EAED"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_7855_927">
                        <rect width={24} height={24} fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )
    }

    return <svg
        width="24px"
        height="24px"
        viewBox="0 0 44 44"
        fill="none" >
        <g style={{
            transform: "scale(1.6) translate(0px, 3px)"
        }}>
            <rect width={24} height={24} fill="transparent" />
            <path
                d="M13.5 2L13.9961 1.93798C13.9649 1.68777 13.7522 1.5 13.5 1.5V2ZM10.5 2V1.5C10.2478 1.5 10.0351 1.68777 10.0039 1.93798L10.5 2ZM13.7747 4.19754L13.2786 4.25955C13.3047 4.46849 13.4589 4.63867 13.6642 4.68519L13.7747 4.19754ZM16.2617 5.22838L15.995 5.6513C16.1731 5.76362 16.4024 5.75233 16.5687 5.62306L16.2617 5.22838ZM18.0104 3.86826L18.364 3.51471C18.1857 3.3364 17.9025 3.31877 17.7034 3.47359L18.0104 3.86826ZM20.1317 5.98958L20.5264 6.29655C20.6812 6.09751 20.6636 5.81434 20.4853 5.63603L20.1317 5.98958ZM18.7716 7.73831L18.3769 7.43134C18.2477 7.59754 18.2364 7.82693 18.3487 8.00503L18.7716 7.73831ZM19.8025 10.2253L19.3148 10.3358C19.3613 10.5411 19.5315 10.6953 19.7404 10.7214L19.8025 10.2253ZM22 10.5H22.5C22.5 10.2478 22.3122 10.0351 22.062 10.0039L22 10.5ZM22 13.5L22.062 13.9961C22.3122 13.9649 22.5 13.7522 22.5 13.5H22ZM19.8025 13.7747L19.7404 13.2786C19.5315 13.3047 19.3613 13.4589 19.3148 13.6642L19.8025 13.7747ZM18.7716 16.2617L18.3487 15.995C18.2364 16.1731 18.2477 16.4025 18.3769 16.5687L18.7716 16.2617ZM20.1317 18.0104L20.4853 18.364C20.6636 18.1857 20.6812 17.9025 20.5264 17.7034L20.1317 18.0104ZM18.0104 20.1317L17.7034 20.5264C17.9025 20.6812 18.1857 20.6636 18.364 20.4853L18.0104 20.1317ZM16.2617 18.7716L16.5687 18.3769C16.4024 18.2477 16.1731 18.2364 15.995 18.3487L16.2617 18.7716ZM13.7747 19.8025L13.6642 19.3148C13.4589 19.3613 13.3047 19.5315 13.2786 19.7404L13.7747 19.8025ZM13.5 22V22.5C13.7522 22.5 13.9649 22.3122 13.9961 22.062L13.5 22ZM10.5 22L10.0039 22.062C10.0351 22.3122 10.2478 22.5 10.5 22.5V22ZM10.2253 19.8025L10.7214 19.7404C10.6953 19.5315 10.5411 19.3613 10.3358 19.3148L10.2253 19.8025ZM7.73832 18.7716L8.00504 18.3487C7.82694 18.2364 7.59756 18.2477 7.43135 18.3769L7.73832 18.7716ZM5.98959 20.1317L5.63604 20.4853C5.81435 20.6636 6.09752 20.6812 6.29656 20.5264L5.98959 20.1317ZM3.86827 18.0104L3.4736 17.7034C3.31878 17.9025 3.33641 18.1857 3.51472 18.364L3.86827 18.0104ZM5.22839 16.2617L5.62307 16.5687C5.75234 16.4025 5.76363 16.1731 5.65131 15.995L5.22839 16.2617ZM4.19754 13.7747L4.68519 13.6642C4.63867 13.4589 4.46849 13.3047 4.25955 13.2786L4.19754 13.7747ZM2 13.5H1.5C1.5 13.7522 1.68777 13.9649 1.93798 13.9961L2 13.5ZM2 10.5L1.93798 10.0039C1.68777 10.0351 1.5 10.2478 1.5 10.5H2ZM4.19754 10.2253L4.25955 10.7214C4.46849 10.6953 4.63867 10.5411 4.68519 10.3358L4.19754 10.2253ZM5.22839 7.73831L5.65131 8.00503C5.76363 7.82693 5.75234 7.59755 5.62307 7.43134L5.22839 7.73831ZM3.86827 5.98959L3.51472 5.63603C3.33641 5.81434 3.31878 6.09751 3.47359 6.29656L3.86827 5.98959ZM5.98959 3.86827L6.29656 3.47359C6.09752 3.31878 5.81434 3.33641 5.63604 3.51471L5.98959 3.86827ZM7.73832 5.22839L7.43135 5.62306C7.59755 5.75233 7.82694 5.76363 8.00504 5.6513L7.73832 5.22839ZM10.2253 4.19754L10.3358 4.68519C10.5411 4.63867 10.6953 4.46849 10.7214 4.25955L10.2253 4.19754ZM13.5 1.5H10.5V2.5H13.5V1.5ZM14.2708 4.13552L13.9961 1.93798L13.0039 2.06202L13.2786 4.25955L14.2708 4.13552ZM16.5284 4.80547C15.7279 4.30059 14.8369 3.92545 13.8851 3.70989L13.6642 4.68519C14.503 4.87517 15.2886 5.20583 15.995 5.6513L16.5284 4.80547ZM16.5687 5.62306L18.3174 4.26294L17.7034 3.47359L15.9547 4.83371L16.5687 5.62306ZM17.6569 4.22182L19.7782 6.34314L20.4853 5.63603L18.364 3.51471L17.6569 4.22182ZM19.7371 5.68261L18.3769 7.43134L19.1663 8.04528L20.5264 6.29655L19.7371 5.68261ZM20.2901 10.1149C20.0746 9.16313 19.6994 8.27213 19.1945 7.47158L18.3487 8.00503C18.7942 8.71138 19.1248 9.49695 19.3148 10.3358L20.2901 10.1149ZM22.062 10.0039L19.8645 9.72917L19.7404 10.7214L21.938 10.9961L22.062 10.0039ZM22.5 13.5V10.5H21.5V13.5H22.5ZM19.8645 14.2708L22.062 13.9961L21.938 13.0039L19.7404 13.2786L19.8645 14.2708ZM19.1945 16.5284C19.6994 15.7279 20.0746 14.8369 20.2901 13.8851L19.3148 13.6642C19.1248 14.503 18.7942 15.2886 18.3487 15.995L19.1945 16.5284ZM20.5264 17.7034L19.1663 15.9547L18.3769 16.5687L19.7371 18.3174L20.5264 17.7034ZM18.364 20.4853L20.4853 18.364L19.7782 17.6569L17.6569 19.7782L18.364 20.4853ZM15.9547 19.1663L17.7034 20.5264L18.3174 19.7371L16.5687 18.3769L15.9547 19.1663ZM13.8851 20.2901C14.8369 20.0746 15.7279 19.6994 16.5284 19.1945L15.995 18.3487C15.2886 18.7942 14.503 19.1248 13.6642 19.3148L13.8851 20.2901ZM13.9961 22.062L14.2708 19.8645L13.2786 19.7404L13.0039 21.938L13.9961 22.062ZM10.5 22.5H13.5V21.5H10.5V22.5ZM9.72917 19.8645L10.0039 22.062L10.9961 21.938L10.7214 19.7404L9.72917 19.8645ZM7.4716 19.1945C8.27214 19.6994 9.16314 20.0746 10.1149 20.2901L10.3358 19.3148C9.49696 19.1248 8.71139 18.7942 8.00504 18.3487L7.4716 19.1945ZM6.29656 20.5264L8.04529 19.1663L7.43135 18.3769L5.68262 19.7371L6.29656 20.5264ZM3.51472 18.364L5.63604 20.4853L6.34315 19.7782L4.22183 17.6569L3.51472 18.364ZM4.83372 15.9547L3.4736 17.7034L4.26295 18.3174L5.62307 16.5687L4.83372 15.9547ZM3.70989 13.8851C3.92545 14.8369 4.30059 15.7279 4.80547 16.5284L5.65131 15.995C5.20584 15.2886 4.87517 14.503 4.68519 13.6642L3.70989 13.8851ZM1.93798 13.9961L4.13552 14.2708L4.25955 13.2786L2.06202 13.0039L1.93798 13.9961ZM1.5 10.5V13.5H2.5V10.5H1.5ZM4.13552 9.72917L1.93798 10.0039L2.06202 10.9961L4.25955 10.7214L4.13552 9.72917ZM4.80547 7.47159C4.30059 8.27213 3.92545 9.16313 3.70989 10.1149L4.68519 10.3358C4.87517 9.49696 5.20583 8.71138 5.65131 8.00503L4.80547 7.47159ZM3.47359 6.29656L4.83371 8.04528L5.62307 7.43134L4.26295 5.68262L3.47359 6.29656ZM5.63604 3.51471L3.51472 5.63603L4.22182 6.34314L6.34314 4.22182L5.63604 3.51471ZM8.04529 4.83371L6.29656 3.47359L5.68262 4.26294L7.43135 5.62306L8.04529 4.83371ZM10.1149 3.70989C9.16313 3.92545 8.27214 4.30059 7.4716 4.80547L8.00504 5.6513C8.71139 5.20583 9.49696 4.87517 10.3358 4.68519L10.1149 3.70989ZM10.0039 1.93798L9.72917 4.13552L10.7214 4.25955L10.9961 2.06202L10.0039 1.93798Z"
                fill="currentColor"
            />
            <circle cx={12} cy={12} r={4} stroke="currentColor" strokeLinejoin="round" />
        </g>
    </svg>
};

function StatusDetails({ computeMinSize, notificationStatus, row, resultName, showDetails, deploymentData }) {
    return (<>

        <div
            onClick={(e) => {
                if (e.target.classList.contains("notification-status-badge")) {
                    showDetails(computeMinSize, notificationStatus, row, resultName, deploymentData);
                }
            }}
            onDoubleClick={() => {
                showDetails(computeMinSize, notificationStatus, row, resultName, deploymentData);
            }}
            style={{
                paddingTop: 4,
                width: `${computeMinSize}px`,
                maxWidth: `${computeMinSize}px`,
                textWrap: "wrap",
            }}>
            {notificationStatus?.formatted || notificationStatus?.string}


        </div>
    </>
    )
}

function TimeCell({ time, separator = "," }) {
    return (time ? <div style={{ opacity: 0.8, fontSize: 10, display: "flex", gap: 2, flexDirection: "column" }}>{getFormattedDate(time).split(separator).map((item, i) => <div key={`t${i}`}>{item}</div>)}</div> : <></>);
}

function TypeCell({ deploymentId, type, userId, width = "95px", maxWidth = "70px", textAlign = "right", fontSize = 8, paddingLeft = 20 }) {
    return (<div style={{
        opacity: 0.8,
        paddingLeft: !deploymentId ? paddingLeft : 0,
        fontSize: fontSize,
        textAlign: textAlign,
        textTransform: "capitalize",
        width: !deploymentId ? width : "auto",
        maxWidth: maxWidth,
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "wrap"
    }}>
        <div style={{ position: "absolute", marginLeft: textAlign == "right" ? -24 : -42, marginTop: 0 }}>
            {!deploymentId && getIcon(userId)}
        </div>
        {decamelize(type || "")}
    </div>)
}

const NOTIF_CACHE_KEY = "EVENT-LOG-DATA";
const NOTIF_CACHE_LAST_TIMESTAMP_KEY = "EVENT-LOG-DATA-LAST-TIMESTAMP";

const pa = "publishedAt"
const DEFAULT_PA = 1626902467


const countSize = 42;
const EventLog = ({ applications: applicationsIncomming, deployments: deploymentsIncomming, deploymentId = false }) => {
    const [appf_tenant_info] = useState(localStorage.appf_tenant_info?JSON.parse(localStorage.appf_tenant_info):{});
    const deployEnabled = typeof appf_tenant_info.sku!=="undefined"?( appf_tenant_info?.sku == "full-internal" || appf_tenant_info?.sku?.toLowerCase().indexOf("deploy") > -1 ) :false

    const [deployFilter, setDeployFilter] = useState(null);
    const [viewOption, setViewOption] = useState("all");

    const handleViewOptionChange = (e, val) => {
        if (val && val != viewOption) {
            setViewOption(val);
        }
    }

    const [computeMinSize, setComputeMinSize] = useState(200);
    const [computeMinSizeHeight, setComputeMinSizeHeight] = useState(400);

    const thisRef = useRef(null)

    useEffect(() => {
        let width = thisRef.current.offsetWidth - (!deploymentId ? 620 : 160);
        let height = thisRef.current.offsetHeight - 20;

        setComputeMinSize(width > 0 ? width : 200);
        setComputeMinSizeHeight(height > 0 ? height : 400);
    }, [thisRef, setComputeMinSize])


    const pageSizeComputed = Math.min(Math.max(1, Math.floor((window.innerHeight - 144) / 41)), 1000);

    const [dataForModal, setDataForModal] = useState(null);
    const showDetails = (computeMinSize, notificationStatus, row, resultName) => {
        setDataForModal(
            {
                computeMinSize,
                notificationStatus,
                row,
                resultName,
                deploymentData:
                    (typeof deploymentIDList[row?.original?.id] !== 'undefined' ? deployments[deploymentIDList[row?.original?.id]] : {})
            });
    }


    const columns = [{
        accessorKey: "notificationType",
        header: "Type",
        ...DEF__(!deploymentId ? 80 : 20),
        Cell: ({ row }) => {

            // console.log(deployments,deploymentIDList[row?.original?.id],deployments[deploymentIDList[row?.original?.id]])
            return (<>
                <TypeCell deploymentId={deploymentId} type={row?.original?.notificationType} userId={row?.original?.userId} />
            </>);
        }
    },
    {
        accessorKey: pa,
        accessorFn: (row) => {
            return row?.notificationData?.timestamp ? row?.notificationData?.timestamp : row[pa]*1000
        },
        ...DEF__(!deploymentId ? 52 : 20),
        header: "Time",
        Header: () => {
            return <div className="hName">Time</div>
        },
        enableColumnActions: false,
        enableColumnDragging: false,
        enableColumnFilterModes: false,
        enableColumnOrdering: false,
        Cell: ({ row }) => <><TimeCell time={row?.original?.notificationData?.timestamp ? row?.original?.notificationData?.timestamp : 
        (row?.original?.notificationData?.last_updated_date?(row?.original?.notificationData?.last_updated_date *1000):row?.original[pa]*1000)}/></>,
    },
    {
        accessorKey: "userId",
        accessorFn: (row) => {
            if (row?.applicationId) {
                let aName = applications?.find((app) => app.id === row?.applicationId)?.name || ""
                return aName + " " + row?.applicationId;
            } else {
                try {
                    return `${(deployments[deploymentIDList[row?.id]]?.name || "")} ${(deployments[deploymentIDList[row?.id]]?.id || "")} ${row?.deploymentId}`
                } catch (e) {
                }

                return row?.id
            }

        },
        size: 192,
        minSize: 192,
        maxSize: 192,
        header: "ID",
        Cell: ({ row }) => {
            let deploymentData =
                (typeof deploymentIDList[row?.original?.id] !== 'undefined') ?
                    {
                        did: deployments[deploymentIDList[row?.original?.id]]?.id || deploymentIDList[row?.original?.id] || "",
                        dname: deployments[deploymentIDList[row?.original?.id]]?.name || deploymentIDList[row?.original?.id] || ""
                    } : null;

            let aName = applications?.find((app) => app.id === row?.original?.applicationId)?.name || ""
            let missing = false;
            if (aName.length == 0) {
                missing = true;
                aName = row?.original?.applicationId
            }

            return (<>
                {row?.original?.applicationId &&
                    <div className={"notification-status-badge appBadge " + (missing ? "missing" : "")}>{aName}</div>
                }
                {deploymentData &&
                    <div data-id={deploymentData?.did} className="notification-deployment-badge">{deploymentData?.dname}</div>
                }
            </>)
        }
    },


    {
        accessorKey: "status",
        size: computeMinSize,
        maxSize: 9999,
        minSize: computeMinSize,
        accessorFn: (row) => (JSON.stringify(row) || ""),
        header: <><span data-id={`${computeMinSize}`} style={{ marginRight: 50 }}>Status</span><span>Message</span></>,
        Cell: ({ row }) => {
            let notificationStatus = getNotificationStatus(row?.original, getCurrentApplication(applications, row.original.applicationId))
            let resultName = ""
            try {
                let indexN = -1;
                indexN = row?.original?.notificationData?.indexOf("{");

                if (indexN >= 0) {
                    resultName = row?.original?.notificationData?.substring(0, indexN);
                }
            } catch (e) {
            }
            return (<>
                <StatusDetails
                    computeMinSize={computeMinSize}
                    notificationStatus={notificationStatus}
                    row={row}
                    resultName={resultName}
                    showDetails={showDetails}
                    deploymentData={
                        (typeof deploymentIDList[row?.original?.id] !== 'undefined') ?
                            {
                                did: deployments[deploymentIDList[row?.original?.id]]?.id,
                                dname: deployments[deploymentIDList[row?.original?.id]]?.name || ""
                            } : null}
                />
            </>)
        }
    }
    ];
    const [deploymentIDList, setDeploymentIDList] = useState([]);
    const [deployments, setDeployments] = useState(null);
    const [applications, setApplications] = useState(applicationsIncomming || []);

    const [notifications, setNotifications] = useState([]);
    const [itemsFromDB, setItemsFromDB] = useState(window._g.itemsFromDB || null);
    const [elts, setElts] = useState(localStorage[NOTIF_CACHE_LAST_TIMESTAMP_KEY] || DEFAULT_PA)

    const { refetch, loading, data: notificationsData } = useQuery(gql`query eventLog${elts == DEFAULT_PA ? "_full" : `_${parseInt(elts) + 1}`}{
    notifications(publishedAfter: ${parseInt(elts) + 1}) {
      id
      notificationType
      notificationData
      applicationId
      userId
      ${pa}
    }
  }`,
        {
            ...fpnf
        });

    const handleRefresh = useCallback((e) => {
        if( e.shiftKey){
            setElts(DEFAULT_PA)
            setTimeout(() => {
                refetch()
            }, 400);
        }else{
            refetch()
        }
    }, [refetch, setElts]);


    function buildDepList(notif) {
        let depList = {};

        for (let i = 0; i < notif.length; i++) {
            try {
                if (notif[i]?.notificationData?.deployment_id) {
                    depList[notif[i]?.id] = notif[i]?.notificationData?.deployment_id
                }
            } catch (e) { }
        }

        return depList
    }

    useEffect(() => {
        let intervalID = setInterval(() => {
          refetch()
        }, 5000)
    
        return () => clearInterval(intervalID)
      }, [])


    useEffect(() => {
        if (itemsFromDB == null) {
            // console.log("NULL", itemsFromDB)
            getItemDB(NOTIF_CACHE_KEY).then(async notifData => {
                try {
                    let notif = JSON.parse(await decompress(notifData));
                    notif = notif.filter(n => n !== null && typeof n !== 'undefined');
                    if (notif && notif.length > 0) {
                        setItemsFromDB(notif);
                    }
                } catch (e) {/**/ }
            });
        }
        else {
            // console.log("itemsFromDB", itemsFromDB)
            // setItemsFromDB( [...itemsFromDB ] );
        }
    }, []);

    useEffect(() => {
        if (!notificationsData && itemsFromDB?.length > 0) {
            if (deploymentId) {
                setNotifications(itemsFromDB
                    .filter(notification => {
                        if (typeof deploymentId === 'object' && deploymentId.length > 1) {
                            return deploymentId.includes(notification?.notificationData?.deployment_id)
                        } else {
                            if (notification?.notificationData?.deployment_id == deploymentId) {
                                return true
                            } else {
                                return false
                            }
                        }
                    })
                )
            }
            else {
                setNotifications(itemsFromDB)
            }
        }
    }, [itemsFromDB]);


    useEffect(() => {
        if (notificationsData) {
            let notif = [];
            notif = [...notificationsData?.notifications || []].sort((a, b) => b?.publishedAt - a?.publishedAt)

            if (elts == DEFAULT_PA) {

                let writeData = JSON.stringify(
                    notif.map(n => {
                        const { __typename, ...rest } = n;
                        return rest;
                    })
                );

                compress(writeData).then(d => setItemDB(NOTIF_CACHE_KEY, d))

                localStorage[NOTIF_CACHE_LAST_TIMESTAMP_KEY] = notif.length > 0 ? notif[0][pa] : DEFAULT_PA;
                setElts(localStorage[NOTIF_CACHE_LAST_TIMESTAMP_KEY])
            }
            else {
                notif = notif.map(n => {
                    const { __typename, ...rest } = n;
                    return rest;
                }).concat(itemsFromDB && itemsFromDB.length > 0 ? itemsFromDB : [])
            }


            let depList = buildDepList(notif)
            setDeploymentIDList(depList)


            if (notif.length > notifications.length) {
                compress(JSON.stringify(notif)).then(d => setItemDB(NOTIF_CACHE_KEY, d))
                localStorage[NOTIF_CACHE_LAST_TIMESTAMP_KEY] = notif.length > 0 ? notif[0][pa] : DEFAULT_PA;


                if (deploymentId) {
                    setNotifications(notif
                        .filter(notification => {
                            if (typeof deploymentId === 'object' && deploymentId.length > 1) {
                                return deploymentId.includes(notification?.notificationData?.deployment_id)
                            } else {
                                if (notification?.notificationData?.deployment_id == deploymentId) {
                                    return true
                                } else {
                                    return false
                                }
                            }
                        })
                    )
                }
                else {
                    setNotifications(notif)
                }
            }
        }
    }, [notificationsData,setDeploymentIDList,setNotifications, deploymentId,setElts,setItemDB,itemsFromDB]);


    useEffect(() => {
        if (notificationsData) {
            let notif = notificationsData.notifications

            let depList = buildDepList(notif)
            setDeploymentIDList(depList)

            if (deploymentId) {
                setNotifications(notif
                    .filter(notification => {
                        if (notification?.notificationData?.deployment_id == deploymentId) {
                            return true
                        } else {
                            return false
                        }
                    })
                )
            }
            else {
                setNotifications(notif)
            }
        }
    }, [deploymentId]);

    useEffect(() => {
        function processDeployments(data) {
            let newData = {}
            data.map(m => newData[m.deployment_id] = m)
            setDeployments(newData || []);
        }
        if (deploymentsIncomming) {
            processDeployments(deploymentsIncomming)
        } else {
            if (deployEnabled) {
                fetchDeployments(true)
                    .then((data) => {
                        processDeployments(data)
                    })
                    .catch(() => {
                        setDeployments([]);
                        console.warn("Failed to fetch deployments");
                    })
            }else{
                setDeployments([]);
            }
        }
    }, [])


    const mnuData = [
        "all",
        "system",
        "user",
    ]

    const fSystem = notifications.filter(notification => notification.userId === "system");
    const fUser = notifications.filter(notification => notification.userId !== "system");


    
    return (
        <>
            {!applicationsIncomming &&
                <PagedQuery
                    query={_Q_getAllApplicationsPaged}
                    name="getCurrentApplicationsPaged"
                    setData={setApplications}
                    paging={{ page: 1, pageSize: 1000 }}
                    all={true}
                    fetchPolicy={"cache-first"}
                />}


            <div
                ref={thisRef}
                className="discoveryTable"
                style={{
                    background: "var(--background-gradient-main)",
                    borderLeft: "1px solid rgba(255,255,255,0.081)",
                    padding: 0,
                    margin: 0,
                    marginLeft: 0,
                    borderRadius: 0,
                    height: "100vh",
                    overflow: "hidden",
                    minWidth: 1200,
                }}
            >

                {deployments && (notifications || []).length > 0 && <DataTable
                    defaultSorting={[{
                        id: pa,
                        desc: true
                    }]}
                    columns={columns.filter(column => deploymentId ? column.header !== "ID" : true)}
                    data={
                        deploymentId ? notifications.filter(notification => deployFilter == null ? true : notification.notificationData?.deployment_id == deployFilter)
                            : (
                                viewOption === "all" ? notifications :
                                    (viewOption === "system" ? fSystem : fUser )
                            )}
                    tableProps={{
                        defaultColumn: {
                            maxSize: 1400,
                            minSize: 80,
                            size: 120
                        },
                        enableExpanding: false,
                        muiPaginationProps: {
                            rowsPerPageOptions: [5, 50, 100, 1000, pageSizeComputed].filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a - b),
                            showFirstButton: true,
                            showLastButton: true,
                        },
                        initialState: {
                            pagination: { pageIndex: 0, pageSize: pageSizeComputed },
                            density: "compact",
                            sorting: [{ id: pa, desc: true }],
                        },
                        //   renderDetailPanel: ({ row }) => <div className={"gravitonDetails"} style={{ marginLeft: "-10px" }}>
                        //     ... 
                        // </div>,
                        renderTopToolbarCustomActions: () => (
                            <div className="traceability--table" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                <div style={{ display: "flex", flexDirection: "row", width: "200px", height: 32, background: "transparent", paddingLeft: 50, paddingTop: 1 }}>
                                    <HorizontalMenu
                                        addLabel={false}
                                        menuItems={mnuData}
                                        menuValues={mnuData}
                                        value={viewOption}
                                        setValue={setViewOption}
                                        onChangeValue={handleViewOptionChange}>
                                        <div style={{ position: "absolute", marginLeft: -44, marginTop: 6}}>
                                            <EventLogIcon width={32} height={28} />
                                        </div>

                                        <div style={{
                                            minWidth: 235,
                                            fontSize: 18,
                                            marginTop: 9
                                        }} >Event Log
                                        </div>
                                        <div className={"refreshButton"} style={{ marginTop: 4, marginLeft: 1, paddingTop: 2, paddingLeft: 0, paddingRight: 0, width: 38, maxHeight: 28, marginRight: 3 }}
                                            onClick={handleRefresh}>
                                            <RefreshButton loading={loading} />
                                        </div>
                                    </HorizontalMenu>
                                </div>
                            </div>
                        ),
                    }}
                />
                }
            </div>
        </>)
}

export default EventLog;